import { UnitOptions } from '../constants/unit.options';
import { UnitConverter } from '../base/UnitConverter';

export class BitsPerSecUnitConverter extends UnitConverter<
  (typeof UnitOptions)['Bits/sec'][number]['value']
> {
  // 싱글턴 인스턴스
  private static instance: BitsPerSecUnitConverter;

  private constructor() {
    super();
  }

  static getInstance(): BitsPerSecUnitConverter {
    if (!BitsPerSecUnitConverter.instance) {
      BitsPerSecUnitConverter.instance = new BitsPerSecUnitConverter();
    }
    return BitsPerSecUnitConverter.instance;
  }

  protected units = [
    'bit (b)/sec - Bits/sec',
    'byte (B)/sec - Bits/sec',
    'kilobit (kb)/sec',
    'megabit (mb)/sec',
    'gigabit (gb)/sec',
    'terabit (tb)/sec',
    'petabit (pb)/sec',
    'exabit (eb)/sec',
  ] as const;

  protected unitToBase = {
    'bit (b)/sec - Bits/sec': 1,
    'byte (B)/sec - Bits/sec': 8,
    'kilobit (kb)/sec': 1_000,
    'megabit (mb)/sec': 1_000_000,
    'gigabit (gb)/sec': 1_000_000_000,
    'terabit (tb)/sec': 1_000_000_000_000,
    'petabit (pb)/sec': 1_000_000_000_000_000,
    'exabit (eb)/sec': 1_000_000_000_000_000_000,
  };
}
